import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  animations: [
    trigger('imageAnimation', [
      transition('* => *', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ])
    ]),

    trigger('listAnimation', [
      transition('* => *', [
        animate('500ms ease-in', keyframes([
          style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
          style({ opacity: .5, transform: 'translateY(35px)', offset: 0.3 }),
          style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
        ])),
        animate('3000ms', style({ opacity: 1 })),
        animate('500ms ease-out', keyframes([
          style({ opacity: 1, transform: 'translateY(0)', offset: 0 }),
          style({ opacity: .5, transform: 'translateY(35px)', offset: 0.3 }),
          style({ opacity: 0, transform: 'translateY(-75%)', offset: 1.0 }),
        ]))
      ])
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoadingScreenComponent implements OnInit, OnDestroy {
  items: string[] = [
    'loading-screen.list-first',
    'loading-screen.list-second'
  ];

  currentIndex = 0;
  private intervalId?: any;

  ngOnInit(): void {
    this.intervalId = setInterval(() => {
      if (this.items && this.items.length) {
        this.currentIndex = (this.currentIndex + 1) % this.items.length;
      }
    }, 3000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
